import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './title.css'

const Title = ({ text }) => (
  <h1 styleName="title">
    {text}
  </h1>
)

Title.propTypes = {
  text: PropTypes.string,
}

export default CSSModules(Title, styles)



/** WEBPACK FOOTER **
 ** ./src/components/title/title.js
 **/